const Container = ({ children, className }) => {
  return (
    <div className={`lg:px-[120px] px-4 ${className}`}>
      {children}
    </div>
  )
}

export default Container